import { TableDataQa } from 'commons/types/enums'
import { CircularProgress, Page, PageFace, PanelFace } from 'ui/components'
import { Table } from 'ui/components/Table'
import { BSABreadcrumbs } from 'ui/temp'
import { BSA_MODULE_PATH } from '~bank-bsa-reporting/constants'

import { columns } from './columns'
import { FilterForm, Footer, SARsInfo } from './components'
import { SARListItem } from './types'
import { useData } from './useData'

import * as SC from './styles'

const SARBatchList = () => {
  const {
    isFetching,
    data,
    sarItemForInfoView,
    chosenSarItems,
    DeleteConfirmation,
    setSarItemForInfoView,
    startDeleting,
    handleSarItemSelect,
    handleDeleteFromTableMenu,
    tableConfig,
    onPageChange
  } = useData()

  if (!data) {
    return <CircularProgress centered />
  }

  return (
    <Page
      face={PageFace.PRIMARY}
      title={<BSABreadcrumbs title="SAR Batch List" parentUrl={BSA_MODULE_PATH} parentTitle="BSA Reporting" />}
    >
      <DeleteConfirmation />
      {sarItemForInfoView && <SARsInfo item={sarItemForInfoView} onClose={() => setSarItemForInfoView(null)} />}
      <SC.TablePanel rounded shadowed collapsible={false} face={PanelFace.SECONDARY}>
        <FilterForm optionStatus={data.statusOptions} tableConfig={tableConfig} data={data} />
        <Table<SARListItem>
          dataQa={TableDataQa.BP_BATCH_SAR_LIST}
          columns={columns(chosenSarItems, data, setSarItemForInfoView, handleSarItemSelect, handleDeleteFromTableMenu)}
          dataSource={data.items.map((el) => ({
            item: el
          }))}
          loading={isFetching}
          pagination={{
            page: data.form.page,
            size: data.form.size,
            onChange: onPageChange,
            total: data.total || 0
          }}
        />
      </SC.TablePanel>
      <Footer onDeleteBatches={startDeleting} hasChosenItems={!!chosenSarItems.length} />
    </Page>
  )
}

export default SARBatchList
